<template>
  <div class="order-dialog" @contextmenu.stop>
    <el-dialog
      title="收票地址"
      width="600px"
      height="600px"
      top="50px"
      custom-class="order-dialog"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="content-wrapper">
        <div class="address-item">
          <div class="title"><span>*</span> 收货人</div>
          <div class="content">{{ addressInfo.contactor }}</div>
        </div>
        <div class="address-item">
          <div class="title"><span>*</span>所在地区</div>
          <div class="content">{{ addressInfo.province + addressInfo.city + addressInfo.county }}</div>
        </div>
        <div class="address-item">
          <div class="title"><span>*</span>详细地址</div>
          <div class="content">{{ addressInfo.address }}</div>
        </div>
        <div class="address-item">
          <div class="title"><span>*</span>联系电话</div>
          <div class="content">{{ addressInfo.phone }}</div>
        </div>
        <div class="address-item">
          <div class="title"><span>*</span>电子邮箱</div>
          <div class="content">{{ addressInfo.email }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddressInfo',
  data() {
    return {
      dialogVisible: false,
      addressInfo: {}
    }
  },
  props: {
    address: Object
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.addressInfo = this.address
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.order-dialog {
  .address-item {
    display: flex;
    font-size: 14px;
    margin-bottom: 30px;
    justify-content: center;
    .title {
      width: 100px;
      text-align: right;
      margin-right: 45px;
      span {
        color: #df5813;
      }
    }
    .content {
      width: 230px;
      text-align: left;
    }
  }
}
</style>
